import { create } from 'zustand';
import { persist, createJSONStorage, devtools } from 'zustand/middleware';

export const useAppStore = create(
  devtools(
    persist(
      (set, get) => ({
        baseURL: process.env.REACT_APP_API_BASE_URL,

        wordListId: null,
        setWordListId: (id) => set({ wordListId: id }),

        soundboardId: null,
        setSoundboardId: (id) => set({ soundboardId: id }),

        // UI State
        isWordListCollapsed: false,
        toggleWordList: () => set((state) => ({ isWordListCollapsed: !state.isWordListCollapsed })),

        wordListWidth: 0,
        setWordListWidth: (width) => set({ wordListWidth: width }),

        stageWidth: 0,
        setStageWidth: (width) => set({ stageWidth: width }),

        stageHeight: window.innerHeight,
        setStageHeight: (height) => set({ stageHeight: height }),

        stagePos: { x: 0, y: 0 },
        setStagePos: (pos) => set({ stagePos: pos }),
      
        stageScale: 1,
        setStageScale: (scale) => set({ stageScale: scale }),
      
        relativeCenter: { x: 0, y: 0 },
        setRelativeCenter: (center) => set({ relativeCenter: center }),

        isPendingAssignWord: false,
        setIsPendingAssignWord: (value) => set({ isPendingDeleteGroup: value }),

        isPendingDeleteGroup: false,
        setIsPendingDeleteGroup: (value) => set({ isPendingDeleteGroup: value }),

        buttonPopovers: {},
        setButtonPopovers: (popovers) => set({ buttonPopovers: popovers }),

        shapePopovers: {},
        setShapePopovers: (popovers) => set({ shapePopovers: popovers }),

        selectedItem: { type: null, id: null },
        setSelectedItem: (item) => set({ selectedItem: item }),

        assignedWordTooltipVisibility: 'hover',
        setAssignedWordTooltipVisibility: (visibility) => set({ assignedWordTooltipVisibility: visibility }),

        lastUsedShapeColor: '#00bcd4',
        setLastUsedShapeColor: (color) => set({ lastUsedShapeColor: color }),

        lastUsedButtonColor: '#009688',
        setLastUsedButtonColor: (color) => set({ lastUsedButtonColor: color }),

        /** Setup wizard **/
        selectedWords: {}, // category: words
        setSelectedWords: (words) => set({ selectedWords: words }),

        selectedLayout: null,        // 'grid', 'island', etc.
        setSelectedLayout: (layout) => set({ selectedLayout: layout }),

        selectedShape: null,         // 'rectangle', 'hexagon', etc.
        setSelectedShape: (shape) => set({ selectedShape: shape }),

        selectedSpacing: null,         // 'spaced', 'packed'
        setSelectedSpacing: (spacing) => set({ selectedSpacing: spacing }),

        // Optional: clear all setup state
        resetSetup: () =>
          set({
            selectedWords: {},
            selectedLayout: null,
            selectedShape: null,
            selectedSpacing: null,
          }),
      }),
      {
        name: 'app-store', // Unique name for storage
        storage: createJSONStorage(() => sessionStorage), // Use sessionStorage for persistence
        partialize: (state) => ({
          wordListId: state.wordListId,
          soundboardId: state.soundboardId,
          isWordListCollapsed: state.isWordListCollapsed,
          wordListWidth: state.wordListWidth,
          stageWidth: state.stageWidth,
          stageHeight: state.stageHeight,
          buttonPopovers: state.buttonPopovers,
          shapePopovers: state.shapePopovers,
          selectedItem: state.selectedItem,
          assignedWordTooltipVisibility: state.assignedWordTooltipVisibility,
        }), // Specify which parts of the state to persist
      }
    )
  )
);